import './pt-electric-disconnect-switch.css';

export default {
	listeners: {
		mouseenter: true,
		mouseleave: true,
		click: true,
		contextmenu: true
	},
	model: {
		'status': {
			type: 'list',
			format: ['OPEN', 'CLOSED'],
			default: 'OPEN',
			bind: {
				to: 'attr',
				name: 'data-status'
			}
		},
		value: {
			private: true,
			type: 'boolean',
			default: false,
			bind: {
				to: 'attr',
				name: 'data-value'
			}
		},
		input: {
			type: 'boolean',
			default: false,
			bind: {
				to: 'attr',
				name: 'data-input'
			}
		}
	}
};
